export default __webpack_public_path__ + "static/article-the-gift-that-keeps-on-giving-875a7a23dc4ad2e51b7770351773727c.jpg";